import type { Theme } from '@elliemae/ds-system';

const commonLeftBorderStyle = (color: string, hoverColor: string, activeColor: string): string => `

  -webkit-box-shadow: inset 4px 0 0 0 ${color};
          box-shadow: inset 4px 0 0 0 ${color};

  :hover {
    -webkit-box-shadow: inset 4px 0 0 0 ${hoverColor};
            box-shadow: inset 4px 0 0 0 ${hoverColor};
  }

  :active {
    -webkit-box-shadow: inset 4px 0 0 0 ${activeColor};
            box-shadow: inset 4px 0 0 0 ${activeColor};
  }
`;

export const getLeftBorderStyle = (props: { theme: Theme; selected?: boolean; selectedParent?: boolean }): string => {
  if (props.selected || props.selectedParent)
    return commonLeftBorderStyle(
      props.theme.colors.brand[400],
      props.theme.colors.brand[400],
      props.theme.colors.brand[400],
    );

  return commonLeftBorderStyle('transparent', props.theme.colors.brand[300], props.theme.colors.brand[400]);
};
